import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const useDownPayment = () => {
  const {
    state: { downPayment },
    actions: { updateApplicationContext },
  } = useApplicationContext();

  const setDownPaymentAmount = (amount: number): void => {
    updateApplicationContext({
      downPayment: { ...downPayment, amount: { currency: downPayment.amount.currency, amount } },
    });
  };

  return {
    downPayment,
    setDownPaymentAmount,
  };
};
